import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CommonService } from '../common.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuardService implements CanActivate {
  constructor(
    private commonService: CommonService,
    private router: Router
  ) {}

  canActivate(): boolean {
    if (this.commonService.isAuthenticated()) {
      this.router.navigate(['/ads-banner']);
      return false;
    }
    return true;
  }
}
